export default __webpack_public_path__ + "static/banner-4bf35a1bdc44e05b8d7aefdebbba67bf.jpg";